/**
 * Returns a human-readable round label for a single elimination bracket match.
 * finalRound = highest winners-bracket round number in the tournament.
 */
export function getRoundLabel(round, bracketSide, finalRound) {
  if (bracketSide === 'third_place')       return 'Spiel um Platz 3';
  if (bracketSide === 'grand_final')       return 'Grand Final';
  if (bracketSide === 'grand_final_reset') return 'Grand Final Reset';

  if (bracketSide === 'winners') {
    if (round === finalRound)     return 'Finale';
    if (round === finalRound - 1) return 'Halbfinale';
    if (round === finalRound - 2) return 'Viertelfinale';
    if (round === finalRound - 3) return 'Achtelfinale';
    return `Runde ${round}`;
  }

  // Losers bracket (double elimination)
  return `LB Runde ${round}`;
}
